import { scrollToSection } from "./sectionNavigation";

export const contactFormSelector = "#contact";

/** Navigate CTA buttons directly to the top of the visible contact form card. */
export function scrollToContactForm() {
  return scrollToSection(contactFormSelector);
}
